import React from "react";
import { string, number } from "prop-types";

import "./star.m.css";

const StarRating = ({ star, index }) => {
  const isHalfStar = star === "half-star";
  const gradientID = `Gradient-${index}-${Math.floor(Math.random() * 100)}`;
  const gradient = isHalfStar ? `url(#${gradientID})` : "#ffffff";
  const pathId = `path-${index}`;

  return (
    <svg styleName={`star ${star}`} width="40px" height="58px" viewBox="0 0 24 35" version="1.1">
      <defs>
        <path
          d="M22.8951306,34.6738871 L12.2982248,21.8553748 C12.2982248,21.8553748 7.92665652,21.7684493 6.26996805,21.6617788 C1.74678053,21.3704216 -0.129477792,18.3294713 0.00690701185,14.1115343 C0.00690701185,14.1115343 0.0455977364,8.13726721 0.206647877,5.34529483 C0.444354017,1.22511896 2.48287157,-0.225647197 6.63680448,0.0279057926 C9.82250202,0.222464971 13.8729372,0.827572912 15.8575296,1.24582699 C18.43675,1.78929242 20.1882308,2.9995083 21.0977046,6.49218266 C21.5460334,8.21359797 22.4850089,13.288992 22.8956142,15.5427963 C23.3570011,18.0761591 23.1758802,20.7778348 19.7125767,21.4043732 L22.8951306,34.6738871 Z M11.4130435,3.80434783 L13.2712945,9.04970185 L18.2608696,9.04970185 L14.189837,12.1300911 L15.6453113,17.5372752 L11.4130435,14.2952119 L7.18124259,17.5372752 L8.63640563,12.1300911 L4.56521739,9.04970185 L9.55494812,9.04970185 L11.4130435,3.80434783 Z"
          id={pathId}
        ></path>
        {isHalfStar && (
          <linearGradient id={gradientID} x1="1" x2="0" y1="0" y2="0">
            <stop styleName="stop-blank" offset="50%" stopOpacity="1" stopColor="#ffffff" />
            <stop styleName="stop-fill" offset="50%" stopOpacity="1" />
          </linearGradient>
        )}
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Review-Desktop" transform="translate(-225.000000, -801.000000)">
          <g id="Group-14" transform="translate(166.000000, 801.000000)">
            <g id="Rectangle" transform="translate(59.347826, 0.000000)">
              <mask id="mask-2" fill="white">
                <use xlinkHref={`#${pathId}`}></use>
              </mask>
              <use id="Mask" fillOpacity="1" fill={gradient} xlinkHref={`#${pathId}`}></use>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

StarRating.propTypes = {
  star: string,
  index: number
};

export default StarRating;
